<div #refModalTrigger><ng-content select="[trigger]"></ng-content></div>
@if ((refModalTrigger.children.length == 0)) {
  <div>
    <button nz-button nzType="primary" (click)="showModal(null)">
      <i nz-icon nzType="plus-circle" nzTheme="outline"></i><span>{{triggerTitle}}</span>
    </button>
  </div>
}
<nz-modal
  [nzMaskClosable]="false"
  [nzNoAnimation]="true"
  [nzVisible]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="1200"
  >
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <nz-spin [nzSpinning]="isLoading">
      <app-add-edit-form
        #form
        [editObject]="object"
        [bulkContainer]="bulkContainer"
        (formFinished)="onFormFinished($event)"
      ></app-add-edit-form>
    </nz-spin>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Abbrechen</button>
    <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isConfirmLoading">Speichern</button>
  </ng-template>
</nz-modal>
